import React, { Component } from 'react'
import { connect } from 'react-redux'
import { loadReferenceData } from '../actions'
import { Map, List, fromJS } from 'immutable'
import { Loader, Message, Dropdown, Popup, Icon, Checkbox } from 'semantic-ui-react'

class ReferenceList extends Component {
  render() {
    let { value: fieldValue, options, onChange } = this.props

    return (
      <div className="reference-list">
        {options.map(({ key, text, value }) => {
          let checked = fieldValue === value
          let classes = ['reference-list-item']
          if (checked) classes.push('reference-list-item--selected')

          return (
            <button className={classes.join(' ')} key={key} onClick={e => e.preventDefault() & onChange(value)}>
              <Checkbox checked={checked} />
              {text}
            </button>
          )
        })}
      </div>
    )
  }
}

class ReferenceContainer extends Component {
  componentDidMount() {
    let { loadReferenceData, referenceConfig = {}, referenceData, referenceLoading } = this.props

    let { id = false, options = {} } = referenceConfig

    let loading = referenceLoading.get(id, false)
    let data = referenceData.get(id, List())

    if (data.size || loading) return

    if (id) loadReferenceData(id, options)
  }

  render() {
    let {
      name,
      value,
      referenceConfig,
      referenceData,
      referenceLoading,
      referenceError,
      placeholder = 'Valitse',
      onChange,
      disabled = false,
      inputType = 'dropdown',
    } = this.props

    if (!referenceConfig) return <div>{`No referenceConfig found`}</div>

    let { id } = referenceConfig

    let loading = referenceLoading.get(id, true)
    let error = referenceError.get(id, false)
    let data = referenceData.get(id, List())
    let multiple = referenceConfig.multiple || false

    if (List.isList(value)) value = value.toJS()

    if (multiple && !Array.isArray(value)) value = []

    if (!multiple && Array.isArray(value)) value = value[0]

    let input = `No input found for ${inputType}`

    if (inputType === 'dropdown')
      input = (
        <Dropdown
          search
          fluid
          selection
          selectOnNavigation={false}
          selectOnBlur={false}
          placeholder={placeholder}
          multiple={multiple}
          value={value}
          disabled={disabled}
          onChange={(e, { value }) => onChange({ name, value })}
          loading={loading}
          options={data.toJS().map(item => ({ key: item.id, text: item.text || item.id, value: item.id }))}
        />
      )

    if (inputType === 'list')
      input = (
        <ReferenceList
          value={value}
          options={data.toJS().map(item => ({ key: item.id, text: item.text || item.id, value: item.id }))}
          onChange={value => onChange({ name, value })}
        />
      )

    return (
      <div className="form-input form-input--reference">
        {error ? <Message content={error} negative visible /> : input}
        {value ? (
          <span
            className="button-plain form-remove-button"
            onClick={e => e.preventDefault() & onChange({ name, value: null })}>
            Poista
          </span>
        ) : null}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    referenceData: state.formData.get('_referenceData', Map()),
    referenceLoading: state.formData.get('_referenceLoading', Map()),
    referenceError: state.formData.get('_referenceError', Map()),
  }
}

function mapDispatchToProps(dispatch) {
  return {
    loadReferenceData: (id, options) => dispatch(loadReferenceData(id, options)),
  }
}

const Reference = connect(mapStateToProps, mapDispatchToProps)(ReferenceContainer)

export default Reference

export function ReferenceButton({ value, text, onChange, placeholder = 'Aseta arvo', referenceConfig, icon = false }) {
  let classes = ['reference-button-item', 'button-plain']
  if (!value) classes.push('reference-button-item--placeholder')

  let trigger = (
    <button className={classes.join(' ')}>
      {icon ? <Icon name={icon} /> : null}
      {text ? text : placeholder}
    </button>
  )

  let content = (
    <div className="reference-button-portal">
      <Reference value={value} onChange={onChange} inputType="list" referenceConfig={referenceConfig} />
    </div>
  )

  return (
    <div className="reference-button">
      <Popup
        trigger={trigger}
        content={content}
        style={{ margin: 0, padding: 0, borderRadius: 0 }}
        on="click"
        position="bottom right"
      />
    </div>
  )
}
